import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_COURSE_TYPE_DETAILS_MUTATION } from '../graphql/mutations'
import { transformToUpdateCourseTypeDetailsArgs } from '../graphql/transformers'
import { UPDATE_COURSE_TYPE_DETAILS } from '../redux/action-types'

const useUpdateCourseTypeDetailsMutation = () => {
  const dispatch = useDispatch()

  const { isUpdateDetailsLoading: isLoading, updateDetailsError: error } =
    useSelector(store => store.courseTypes.courseType)

  const mutate = useCallback(
    (id, data) =>
      apolloService.mutate(
        UPDATE_COURSE_TYPE_DETAILS_MUTATION,
        { id, data: transformToUpdateCourseTypeDetailsArgs(data) },
        dispatch,
        UPDATE_COURSE_TYPE_DETAILS,
      ),
    [dispatch],
  )

  return [mutate, { isLoading, error }]
}

export default useUpdateCourseTypeDetailsMutation
